(function () {
  'use strict';
  if (window.__orderBarInit) return;
  window.__orderBarInit = true;

  function fmtNum(n) {
    if (n >= 1000000) {
      var m = n / 1000000;
      return (m % 1 === 0 ? m.toFixed(0) : m.toFixed(1).replace(/\.0$/, '')) + 'M';
    }
    if (n >= 1000) {
      var k = n / 1000;
      if (k >= 100) return k.toFixed(0) + 'K';
      if (k >= 10) return k.toFixed(0) + 'K';
      return (k % 1 === 0 ? k.toFixed(0) : k.toFixed(1).replace(/\.0$/, '')) + 'K';
    }
    return String(n);
  }

  function sub(t, n) { return t.replace('{{ n }}', n).replace('{{n}}', n); }

  function relativeTime(secs, tpl) {
    if (secs < 60) return tpl.just;
    if (secs < 3600) return sub(tpl.min, Math.floor(secs / 60));
    if (secs < 86400) return sub(tpl.hour, Math.floor(secs / 3600));
    var days = Math.floor(secs / 86400);
    if (days === 1) return tpl.yesterday;
    return sub(tpl.day, days);
  }

  function getTpl(el) {
    return {
      deliv: el.getAttribute('data-tpl-delivered') || '{{ qty }} {{ noun }} delivered',
      just:  el.getAttribute('data-tpl-just-now')  || 'just now',
      min:   el.getAttribute('data-tpl-min')       || '{{ n }} min. ago',
      hour:  el.getAttribute('data-tpl-hour')      || '{{ n }} hour ago',
      day:   el.getAttribute('data-tpl-day')       || '{{ n }} day ago',
      yesterday: el.getAttribute('data-tpl-yesterday') || 'yesterday'
    };
  }

  // Capped to last 48 hours, low-volume catalog.
  function randomElapsed() {
    var r = Math.random();
    if (r < 0.10) return 30 * 60 + Math.floor(Math.random() * 30 * 60);      // 10%  30-60 min
    if (r < 0.35) return 3600 + Math.floor(Math.random() * 5 * 3600);        // 25%  1-6 hr
    if (r < 0.60) return 6 * 3600 + Math.floor(Math.random() * 6 * 3600);    // 25%  6-12 hr
    if (r < 0.85) return 12 * 3600 + Math.floor(Math.random() * 12 * 3600);  // 25%  12-24 hr
    return 86400 + Math.floor(Math.random() * 86400);                         // 15%  24-48 hr
  }

  function buildBatch(pool, size) {
    var entries = [];
    for (var i = 0; i < size; i++) {
      entries.push({ qty: pool[Math.floor(Math.random() * pool.length)], elapsed: randomElapsed() });
    }
    // Sort by elapsed ASC → newest first → chronological display order
    entries.sort(function (a, b) { return a.elapsed - b.elapsed; });
    for (var j = 1; j < entries.length; j++) {
      if (entries[j].qty === entries[j - 1].qty && pool.length > 1) {
        var alt = pool.filter(function (n) { return n !== entries[j].qty; });
        if (alt.length) entries[j].qty = alt[Math.floor(Math.random() * alt.length)];
      }
    }
    return entries;
  }

  function renderTick(el) {
    var pool = el.__orderPool;
    if (!pool || !pool.length) return;
    if (!el.__orderBatch || el.__orderIdx >= el.__orderBatch.length) {
      el.__orderBatch = buildBatch(pool, 8);
      el.__orderIdx = 0;
    }
    var entry = el.__orderBatch[el.__orderIdx++];
    var noun = el.getAttribute('data-noun') || '';
    var tpl = getTpl(el);

    var msg = tpl.deliv
      .replace('{{ qty }}', '<strong>' + fmtNum(entry.qty) + '</strong>')
      .replace('{{qty}}', '<strong>' + fmtNum(entry.qty) + '</strong>')
      .replace('{{ noun }}', noun)
      .replace('{{noun}}', noun);
    var time = relativeTime(entry.elapsed, tpl);

    var msgEl = el.querySelector('[data-order-msg]');
    var timeEl = el.querySelector('[data-order-time]');
    if (!msgEl || !timeEl) return;

    el.setAttribute('data-order-fade', '');
    setTimeout(function () {
      msgEl.innerHTML = msg;
      timeEl.textContent = time;
      el.removeAttribute('data-order-fade');
    }, 220);
  }

  function init(el) {
    if (el.__orderInit) return;
    el.__orderInit = true;
    var rotateMs = parseInt(el.getAttribute('data-rotate-ms') || '15000', 10);
    if (isNaN(rotateMs) || rotateMs < 4000) rotateMs = 15000;
    var pool = (el.getAttribute('data-pool') || '').replace(/[\[\]\s"]/g, '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n) && n > 0; });
    el.__orderPool = pool;
    el.__orderBatch = null;
    el.__orderIdx = 0;
    renderTick(el);
    var paused = false;
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });
    function schedule() {
      var jitter = 0.85 + Math.random() * 0.3;
      setTimeout(function () {
        if (!paused) renderTick(el);
        schedule();
      }, Math.floor(rotateMs * jitter));
    }
    schedule();
  }

  function boot() {
    var bars = document.querySelectorAll('[data-order-bar]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
